import { Loan } from '../types/loan'

export function exportLoansToCSV(
  loans: Loan[],
  currentMarketRate: number,
  filename: string = 'refinance_opportunities.csv',
) {
  // Define CSV headers
  const headers = [
    'Loan ID',
    'Borrower Name',
    'Email',
    'Phone',
    'Loan Amount',
    'Interest Rate (%)',
    'Current Market Rate (%)',
    'Rate Difference (%)',
    'Close Date',
    'Loan Term (Months)',
    'Property Type',
  ]

  // Map loans to CSV rows
  const rows = loans.map((loan) => {
    const rateDiff = loan.interestRate - currentMarketRate
    return [
      loan.id,
      `"${loan.borrowerName}"`, // Quote strings that might contain commas
      loan.email,
      loan.phone,
      loan.loanAmount,
      loan.interestRate,
      currentMarketRate,
      rateDiff.toFixed(3),
      loan.closeDate,
      loan.loanTerm,
      `"${loan.propertyType}"`,
    ]
  })

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.join(',')),
  ].join('\n')

  // Create a Blob and download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
